import $ from 'jquery';

(function(){
    'use strict';

    // Global variables
    var dsd = {
        'fn': {},
        'vars': {}
    };

    dsd.utils = {
        'addMouseBodyClass': function() {
            $('body').removeClass('using-keys');
        },
        'addKeyboardBodyClass': function() {
            $('body').addClass('using-keys');
        },
        'detectUserInteraction': function() {
            $('body').on('mousedown', this.addMouseBodyClass);
            $('body').on('keydown', this.addKeyboardBodyClass);
        }
    }

    // Functions
    dsd.fn = {
        'init': function () {
            dsd.utils.detectUserInteraction();
        }
    }

    // Make dsd variable available to the console for debugging
    window.dsd = dsd;

    $(document).ready(function () {
        dsd.fn.init();
    });
}());
